import React from "react";
import { useUser } from "../../../hooks/useUser";

interface UserNameProps {
  userId: string;
  fallback?: string;
}

export const UserName: React.FC<UserNameProps> = ({
  userId,
  fallback = "N/A",
}) => {
  const { data: user, isLoading, isError } = useUser(userId);

  if (isLoading) {
    return <span className="text-slate-400">Loading...</span>;
  }

  if (isError || !user) {
    return <span className="text-slate-400">{fallback}</span>;
  }

  return <span className="text-slate-300">{user.name}</span>;
};
